import React, { RefObject } from 'react'
import gql from 'graphql-tag'
import styled, { css } from 'styled-components'
import { AvatarUserFragment, Maybe } from '~/common/types/graphql'

import { COLORS, SIZES, FONT_WEIGHTS } from '~/common/globalStyles'
interface AvatarFragmentProps {
  user: AvatarUserFragment
}
interface AvatarProps {
  imageUrl?: Maybe<string> | undefined
  name1?: string
  name2?: string
  fontSize?: string
  size?: string
  square?: boolean
  borderless?: boolean
  blank?: boolean
  style?: React.CSSProperties
  height?: string
  ref?: any
}

const getInitials = (name1?: string, name2?: string) => {
  return [name1 && name1.slice(0, 1), name2 && name2.slice(0, 1)].join('')
}

const AvatarDiv = styled.div<AvatarProps>`
  font-size: ${({ fontSize }) => fontSize || SIZES.small};
  line-height: ${({ fontSize }) => fontSize || SIZES.small};
  text-transform: uppercase;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  min-width: ${({ size }) => size};
  min-height: ${({ size }) => size};
  border-radius: ${({ square }) => (square ? '0' : '50%')};
  background-color: ${COLORS.lighterGray};
  color: ${COLORS.white};
  font-weight: ${FONT_WEIGHTS.bold};
  display: inline-flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${({ borderless }) =>
    !borderless &&
    css`
      border: 1px solid ${COLORS.lighterGray};
    `};
  ${({ imageUrl }) =>
    imageUrl &&
    css`
      background-image: url(${imageUrl});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      border-color: ${COLORS.lighterGray};
      background-color: ${({ theme }) => theme.palette.background.default};
    `};
  ${({ imageUrl, name1, name2, blank }) =>
    !imageUrl &&
    !name1 &&
    !name2 &&
    !blank &&
    css`
      background-image: url('https://cdn.guidecx.com/static/images/generic-profile.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      border-color: ${COLORS.lighterGray};
      background-color: ${COLORS.white};
    `};
`
/*@ts-ignore*/
const Avatar: FragC<AvatarFragmentProps, AvatarProps> = React.forwardRef<
  RefObject<HTMLDivElement>,
  Partial<AvatarFragmentProps & AvatarProps>
>(
  (
    { imageUrl = '', name1 = '', name2 = '', size = SIZES.xxxl, ...props },
    ref,
  ) => {
    return (
      <AvatarDiv
        ref={ref}
        data-testid="avatar"
        imageUrl={imageUrl}
        name1={name1}
        name2={name2}
        size={size}
        {...props}
      >
        {!imageUrl && getInitials(name1, name2)}
      </AvatarDiv>
    )
  },
)

Avatar.fragments = {
  user: gql`
    fragment Avatar_User on UserType {
      id
      firstName
      lastName
      avatar {
        originalUrl
      }
    }
  `,
}

export default Avatar
